<template>
  <div v-loading.fullscreen.lock="loading" class="address_list">
    <!-- 头部 -->
    <top-part :rightPart="true">
      <template slot="difinePort">
          <div class="address_top_right" >
            <img src="@/images/add.png" />
            <span @click='toEdit'>新增地址</span>
          </div>
      </template>
    </top-part>
    <!-- 头部 结束 -->

    <div v-if="addressList&&addressList.length" class="ctn_top">
      <van-radio-group v-model="checkedItem" @change="radioChange">
        <van-radio :name="item.id" v-for="item in addressList" :key="item.id" @click="radioClick">
          <div class="address_item">
            <div>
              <div class="name_phone">
                <div class="address_name">{{item.receiverName}}</div>
                <span>{{item.receiverPhone}}</span>
              </div>
              <p>{{item.provinceName}}{{item.cityName}}{{item.areaName}}{{item.address}}</p>
            </div>
            <img src="@/images/edit_gray.png" alt @click='toEdit(item)' />
          </div>
        </van-radio>
      </van-radio-group>
    </div>

    <!-- 没数据时 -->
    <div class="blank" v-else>
      <img src="@/images/404-02.png" alt>
    </div>
</div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import topPart from "../../components/topPart";
import { toast } from "@/common/api/api.js";
export default {
  components: {
    topPart
  },
  data() {
    return {
      loading:true,
      checkedItem:'1',
      addressList:[],//地址list
      category:''
    };
  },
  mounted(){
    const {id,welfareCategory} = this.$route.query;
    this.checkedItem=id;
    this.category = welfareCategory
    this.getAddressList();
  },
  methods:{
    // 获取用户地址列表
    getAddressList(){
      this.centralControl.axios.centralControl(
          "getAddressByStaff",
          res => {
            this.loading=false;
            if (res.code == 200) {
              this.addressList=res.data;
              // 用户选中的默认地址
              let _index=this.addressList.findIndex(item=>{return item.defaultAddress==1})
              if(_index>=0)this.checkedItem=this.addressList[_index].id;
            } else {
              toast(this, res.message);
            }
          },
          {}
        );
      
    },
    // 跳转--编辑/新增
    toEdit(item){
      let obj = {
        path:'addressNew',
        query:{
          welfareCategory:this.category
        }
      }
      if(item.id)obj.query={id:item.id};
      this.$router.push(obj)
    },
    // 单选框改变时
    radioChange(e){
      const {id} = this.$route.query;
      let _index=this.addressList.findIndex(item=>{return item.id==e})
      let data={};
      if(_index>=0)data=this.addressList[_index];
      if(id){
        // 从订单点进来 
        // this.centralControl.notice.emitBrother("addressList",data);
        // this.$router.go(-1);
      } else {
        //从地址管理点进来
        this.setDefault(data);
      }
      
    },
    radioClick(e){
      const {id} = this.$route.query;
      let _index=this.addressList.findIndex(item=>{return item.id==this.checkedItem})
      let data={};
      if(_index>=0)data=this.addressList[_index];
      if(id){
        // 从订单点进来 
        this.centralControl.notice.emitBrother("addressList",data);
        this.$router.go(-1);
      } else {
        //从地址管理点进来
        // this.setDefault(data);
      }
    },
    // 设置改地址为默认状态
    setDefault(data){
      data.defaultAddress=1;
      data.welfareCategory = this.category
      
      this.centralControl.axios.centralControl(
        "addOrUpdateAddress",
        res => {
          if (res.code == 200) {
            toast(this, '已设为默认地址','success');
          } else {
            toast(this, res.message,"error");
          }
        },
        data
      );
    }
  }
}
</script>
<style lang="stylus" type="stylesheet/stylus">
@import "../../assets/stylus/common"
  .address_list{
    .top-box {
      justify-content: space-between;
    }
    .address_top_right {
      margin-right: 16px;
      img {
        width: 18px;
        margin-right: 6px;
      }
      span {
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(41,190,188,1);
      }
    }
    .van-radio {
      padding: 16px;
      background: #FFF;
      border-bottom: 1px solid #EFEFF4;
    }
    .van-radio__label {
      width: 100%;
      margin-left: 16px;
    }
    .van-radio__icon--checked .van-icon{
      background-color: #29BEBC;
      border-color: #29BEBC;
    }
    .van-radio__icon .van-icon {
      font-size: 20px;
    }
    .address_item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      img {
        width: 24px;
        height: 24px;
      }
      .name_phone {
        display: flex;
        line-height: 28px;
        div {
          font-size:15px;
          font-family:PingFang SC;
          font-weight:bold;
          color:rgba(51,51,51,1);
          margin-right: 6px;
          ellipsis();
          max-width: 76px;
        }
        span {
          font-size:13px;
          font-family:PingFang SC;
          font-weight:500;
          color:rgba(136,136,136,1);
        }
      }
      p {
        font-size:14px;
        font-family:PingFang SC;
        font-weight:500;
        color:rgba(136,136,136,1);
      }
    }
  }
</style>